import Queue from './queue';
import Node from './node';

type GraphNodeOptions = {
  coords?: number[];
  neighbours?: GraphNode[];
  hasVisited?: boolean;
};

export class GraphNode extends Node {
  neighbours: GraphNode[];
  hasVisited: boolean;

  constructor(
    value: string,
    { coords, neighbours, hasVisited }: GraphNodeOptions
  ) {
    super(value, { coords });
    this.neighbours = neighbours || [];
    this.hasVisited = hasVisited || false;
  }
}

export default class Graph {
  nodeList: GraphNode[];

  constructor(nodeList: GraphNode[]) {
    this.nodeList = nodeList;
  }

  bfs(): GraphNode[] {
    const resultList: GraphNode[] = [];
    const queue = new Queue();

    for (const node of this.nodeList) {
      if (node.hasVisited) continue;
      queue.enqueue(node);
      while (!queue.isEmpty()) {
        const firstNode = queue.dequeue();
        if (firstNode instanceof GraphNode) {
          if (firstNode.hasVisited) continue;
          firstNode.hasVisited = true;
          resultList.push(firstNode);

          for (const neighbour of firstNode.neighbours) {
            if (neighbour.hasVisited) continue;
            queue.enqueue(neighbour);
          }
        }
      }
    }
    return resultList;
  }

  dfs(): GraphNode[] {
    const resultList: GraphNode[] = [];
    const stack: GraphNode[] = [];

    for (const node of this.nodeList) {
      if (node.hasVisited) continue;
      stack.push(node);
      while (stack.length > 0) {
        const lastNode = stack.pop();
        if (lastNode.hasVisited) continue;
        lastNode.hasVisited = true;
        resultList.push(lastNode);

        for (const neighbour of lastNode.neighbours) {
          if (neighbour.hasVisited) continue;
          stack.push(neighbour);
        }
      }
    }
    return resultList;
  }

  addUndirectedEdge(i: number, j: number): void {
    const first = this.nodeList[i - 1];
    const second = this.nodeList[j - 1];
    first.neighbours.push(second);
    second.neighbours.push(first);
  }
}
